export default {"src":"/_next/static/image/public/images/ic_share_grey.b8d5a0500b8ed6501f8b01c13cdce22b.svg","height":20,"width":18};